import { Container, Col, Row } from "react-bootstrap";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import { TelephoneForward, At, GeoAlt, Whatsapp } from "react-bootstrap-icons";
import "../style/Footer.css";

const Footer = () => {
  return (
    <footer className="bbf-footer">
      <Container className="container-narrow">
        <Row className="bbf-footer__top">
          <Col lg={4} md={6} className="mb-4 mb-lg-0">
            <img src="/images/logo.png" alt="Bit Byte Foods" className="bbf-footer__logo" />
            <p className="bbf-footer__address">
              <GeoAlt size={18} className="me-2" />
              Kote Cafe (formerly Idly Dosa Camp), Shop 2, Jain Mandir
              Complex, Vidyagiri, Bagalkot, Karnataka 587102
            </p>
          </Col>

          <Col lg={2} md={6} className="mb-4 mb-lg-0">
            <h5>Explore</h5>
            <ul className="bbf-footer__links">
              <li><a href="/kotecafe">Kote Cafe</a></li>
              <li><a href="/gallery">Gallery</a></li>
              <li><a href="/franchise">Franchise</a></li>
              <li><a href="/faq">FAQ</a></li>
            </ul>
          </Col>

          <Col lg={2} md={6} className="mb-4 mb-lg-0">
            <h5>Support</h5>
            <ul className="bbf-footer__links">
              <li><a href="/contactus">Contact Us</a></li>
              <li><a href="/privacypolicy">Privacy Policy</a></li>
            </ul>
          </Col>

          <Col lg={4} md={6}>
            <h5>Get in Touch</h5>
            <p className="bbf-footer__contact">
              <Whatsapp size={18} className="me-2" />
              <a
                href="https://api.whatsapp.com/send?phone=916363018056"
                target="_blank"
                rel="noreferrer"
              >
                WhatsApp Us
              </a>
            </p>
            <p className="bbf-footer__contact">
              <TelephoneForward size={18} className="me-2" />
              <a href="tel:+916363018056">+91 63630 18056</a>
            </p>
            <p className="bbf-footer__contact">
              <At size={18} className="me-2" />
              <a href="mailto:bitbytefoods@gmail.com">bitbytefoods@gmail.com</a>
            </p>
            <div className="bbf-footer__social">
              <a
                href="https://www.facebook.com/bitbytefoods"
                aria-label="Bit Byte Foods on Facebook"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebook />
              </a>
              <a
                href="https://www.youtube.com/@BitByte-Batter"
                aria-label="Bit Byte Foods on YouTube"
                target="_blank"
                rel="noreferrer"
              >
                <FaYoutube />
              </a>
              <a
                href="https://www.instagram.com/bitbytefoods/"
                aria-label="Bit Byte Foods on Instagram"
                target="_blank"
                rel="noreferrer"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.linkedin.com/company/bit-byte-foods/"
                aria-label="Bit Byte Foods on LinkedIn"
                target="_blank"
                rel="noreferrer"
              >
                <FaLinkedinIn />
              </a>
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="bbf-footer__bottom">
              ©{new Date().getFullYear()} Bit Byte Foods. All rights reserved. Site
              developed by{" "}
              <a
                href="https://springeveningpl.com/"
                target="_blank"
                rel="noreferrer"
              >
                Springevening Private Limited
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
